import React from 'react'
import { Checkbox, Form } from 'semantic-ui-react'

import { TooltipLabel } from 'components/TooltipLabel'

/**
 * @param {object} props
 * @param {string} props.embedStyleType
 * @param {function} props.setEmbedStyleType
 * @param {boolean} props.shouldHandleImagesNotLoaded
 * @param {function} props.setShouldHandleImagesNotLoaded
 * @param {boolean} props.shouldShowLabel
 * @param {function} props.setShouldShowLabel
 * @param {string=} props.className
 * @param {string} props.iconSizeLabel
 * @param {function} props.setIconSizeLabel
 * @param {boolean} props.shouldShowHandleImagesNotLoadedCheckbox
 * @param {boolean=} props.hideEmojis
 */
export default function EmbedRatingIconSelectorForm({
  embedStyleType,
  setEmbedStyleType,
  className,
  shouldHandleImagesNotLoaded,
  setShouldHandleImagesNotLoaded,
  shouldShowLabel,
  setShouldShowLabel,
  shouldShowHandleImagesNotLoadedCheckbox,
  hideEmojis = false,
}) {
  function handleChange(_, { value }) {
    setEmbedStyleType(value)
  }

  const textLabelsDescriptionContent = (
    <>
      <p>
        Displaying text labels under rating images makes it easier for your customers to choose the
        right rating if images fail to load.
      </p>
      <p>
        If you'd like to use different text than the labels from the first question of the survey,
        you can edit the HTML code directly, or ask the Simplesat team for assistance.
      </p>
    </>
  )

  return (
    <Form className={className}>
      <Form.Group grouped>
        <label>Rating icon type</label>
        <Form.Checkbox
          checked={embedStyleType === 'icon'}
          onChange={handleChange}
          radio
          value="icon"
          label="Images"
        />
        {embedStyleType === 'icon' && (
          <React.Fragment>
            <Checkbox
              className="ml3 mt2 mb2"
              checked={shouldShowLabel}
              onChange={(_, { checked }) => setShouldShowLabel(checked)}
              label={
                <TooltipLabel
                  label="Display text labels under rating images"
                  descriptionTitle="Text labels"
                  descriptionContentWithFormat={textLabelsDescriptionContent}
                  learnMoreLink=""
                />
              }
            />
            {shouldShowHandleImagesNotLoadedCheckbox && (
              <Checkbox
                className="ml3 mt2 mb2"
                checked={shouldHandleImagesNotLoaded}
                onChange={(_, { checked }) => setShouldHandleImagesNotLoaded(checked)}
                label={
                  <TooltipLabel
                    label="Display colored boxes if images doesn't load"
                    descriptionTitle="Image background color"
                    descriptionContent="When this option is selected, images that fail to load will display a colored box in their place. The only reason not to choose this option is if you prefer the rating images to use a transparent background."
                    learnMoreLink=""
                  />
                }
              />
            )}
          </React.Fragment>
        )}
        {!hideEmojis && (
          <Form.Checkbox
            checked={embedStyleType === 'emoji'}
            onChange={handleChange}
            radio
            value="emoji"
            label="Emojis"
          />
        )}
      </Form.Group>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EmbedRatingIconSelectorForm/index.js